// extracted by mini-css-extract-plugin
export default {"loader":"TableSwitch_loader__ducg2"};